import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { getProducts, getCategories } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [active, setActive] = useState("All");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    getCategories().then((c) => setCategories(["All", ...c])).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    getProducts(active === "All" ? {} : { category: active })
      .then(setProducts)
      .finally(() => setLoading(false));
  }, [active]);

  return (
    <div data-testid="shop-page" className="bg-bone pt-[72px] min-h-screen">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="py-14 md:py-20 max-w-2xl">
          <span className="text-xs uppercase tracking-[0.2em] font-bold text-forest">The Catalog</span>
          <h1 className="font-display text-5xl md:text-6xl tracking-tight text-ink mt-4 leading-[1.05]">
            Research-grade peptides.
          </h1>
          <p className="text-lg text-stone leading-relaxed mt-5">
            Every compound is third-party tested and physician-reviewed. Not sure where to begin?
          </p>
          <button
            data-testid="shop-intake-btn"
            onClick={() => navigate("/intake")}
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-forest text-[#14100F] px-6 py-3 text-sm font-semibold hover:bg-forest-dark active:scale-95 transition-[background-color,transform] duration-200"
          >
            <Sparkles className="w-4 h-4" strokeWidth={1.5} /> Let our AI recommend for you
          </button>
        </div>

        <div className="flex flex-wrap gap-2.5 pb-10 sticky top-[72px] bg-bone/80 backdrop-blur-md py-4 z-30 -mx-1 px-1">
          {categories.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c.toLowerCase().replace(/[\s&]+/g, "-")}`}
              onClick={() => setActive(c)}
              className={`px-4 py-2 rounded-full text-sm font-semibold border transition-colors duration-200 ${
                active === c
                  ? "bg-forest text-[#14100F] border-forest"
                  : "bg-transparent text-stone border-line hover:border-forest/40"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 pb-24">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="rounded-xl border border-line bg-sand animate-pulse aspect-[3/4]" />
            ))}
          </div>
        ) : (
          <div data-testid="product-grid" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 pb-24">
            {products.map((p, i) => (
              <ProductCard key={p.slug} product={p} index={i} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
